export default __webpack_public_path__ + "static/media/rehasporthermeskeil_eV.d45f28a9.jpg";